import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectMarketerMarketersCostChart:
    "userSelectMarketerMarketersCostChart [Action]",
  userSelectMarketerMarketersCostChartLoading:
    "userSelectMarketerMarketersCostChartLoading [Action]",
  userSelectMarketerMarketersCostChartAsync:
    "userSelectMarketerMarketersCostChartAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_marketer_marketers_cost_chart_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectMarketerMarketersCostChart:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectMarketerMarketersCostChartLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectMarketerMarketersCostChartLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_marketers_cost_chart",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectMarketerMarketersCostChart,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectMarketerMarketersCostChartLoading,
      payload: false,
    });
  }
}

export function* userSelectMarketerMarketersCostChart() {
  yield takeLatest(
    actionTypes.userSelectMarketerMarketersCostChartAsync,
    handleWorker
  );
}
